// @flow

import addOrderItem from '../../../Services/addOrderItem';
import type { AddOrderItemParams } from '../../../types';

export default (params: AddOrderItemParams) => async (dispatch: Function) => dispatch(addOrderItem(params))